import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { CspTables } from "./CspTables";
import { db } from "../../config/Firebase";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 500,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  chip: {
    margin: 10,
  },
  head: {
    backgroundColor: "#01579b",
    color: "#FFF",
  },
  headFont: {
    color: "#FFF",
  },
  bullFontColor: {
    color: "red",
  },
  pdf: {
    width: "150px",
  },
  pageH: {
    minHeight: "800px",
  },
});

const Alerts = () => {
  const [time, setTime] = useState(null);
  const [csp, setCsp] = useState(null);
  const classes = useStyles();
  const { activeUser } = useAuth();

  useEffect(() => {
    db.collection("daily")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let x;
          if (doc.id === "time") {
            x = doc.data();
            setTime(x);
          }
          console.log(doc.id, " => ", doc.data());
        });
      });
    db.collection("alert")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let x;
          if (doc.id === "csp") {
            x = doc.data();
            setCsp(x);
          }
          console.log(doc.id, " => ", doc.data());
        });
      });
  }, []);

  return (
    <>
      {time === null || csp === null ? (
        <div
          style={{ minHeight: `100vh` }}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="loader"> <CircularProgress /></div>
        </div>
      ) : (
        <div
          className={`pt-5 bg-light-2 ${classes.pageH}`}
          style={{ fontSize: `0.8rem` }}
        >
          <section className="pt-5 mb-5 container">
            <div className="container-fluid">
              <h1 className="text-center font-weight-bold mt-3 mb-3">
                Cash Secured Put Trading Ideas
              </h1>
              <h3 className="text-center font-weight-normal mt-3 mb-3">
                {time?.t}
              </h3>
              <div className="d-flex justify-content-center mb-4">
                <p className="w-50 align-self-center text-center font-weight-light h6 text-black-50 mb-4 py-1">
                  Use Cash Secured Put as your investment strategy to 
                  purchase the stock you like at a pre-specified price
                   while also generating income.
                </p>
                <div className="footer">
                  <div
                    className="iconsBaby d-flex align-items-baseline position-relative"
                    style={{ height: 150 }}
                  >
                   
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="container-fluid">
            <div className="row">
              <div className="col col-xl-8 offset-xl-2 order-last order-xl-first">
                <CspTables
                  csp={csp}
                />
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default Alerts;
